/** Meta WhatsApp template locale codes (curated list for Venttify UI). */
export const WHATSAPP_TEMPLATE_LANGUAGE_OPTIONS = [
  { value: "pt_BR" },
  { value: "en_US" },
  { value: "es_MX" },
];

export const DEFAULT_WHATSAPP_TEMPLATE_LANGUAGE = "es_MX";

/** Aligns bare language codes with Meta regional locales (same as Biz). */
export function normalizeWhatsAppTemplateLanguage(language) {
  const trimmed = String(language ?? "").trim();
  if (trimmed === "es") return "es_MX";
  if (trimmed === "en") return "en_US";
  if (trimmed === "pt") return "pt_BR";
  return trimmed;
}

export function isKnownWhatsAppTemplateLanguage(code) {
  return WHATSAPP_TEMPLATE_LANGUAGE_OPTIONS.some((option) => option.value === code);
}

export function resolveWhatsAppTemplateLanguageOptions(storedLanguage) {
  const trimmed = normalizeWhatsAppTemplateLanguage(storedLanguage);
  if (!trimmed || isKnownWhatsAppTemplateLanguage(trimmed)) {
    return WHATSAPP_TEMPLATE_LANGUAGE_OPTIONS;
  }
  return [...WHATSAPP_TEMPLATE_LANGUAGE_OPTIONS, { value: trimmed, legacy: true }];
}
